import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors } from '@dixa/lib-shared-tokens';
import { TextFit } from 'lib-shared-legacy-components';
import { memo } from 'react';
import styles from './tvDashboardMetric.module.scss';
export const TvDashboardMetric = memo(function TvDashboardMetric({ title, stat, color = colors.blue[400], }) {
    return (_jsxs("div", Object.assign({ className: styles.metric }, { children: [_jsx("div", Object.assign({ className: styles.stat, style: { color } }, { children: typeof stat === 'string' || typeof stat === 'number' ? (_jsx(TextFit, Object.assign({ max: 70 }, { children: stat.toString() }))) : (stat) })), _jsx(TextFit, Object.assign({ className: styles.title, max: 26 }, { children: title }))] })));
});
